export const formatPageNumbers = (pages) => {
  // 如果 pages 不存在或为空数组，返回 null
  if (pages === undefined || pages === null) return null;
  if (Array.isArray(pages) && pages.length === 0) return null;

  if (!Array.isArray(pages)) return `第 ${pages + 1} 页`;
  if (pages.length === 1) return `第 ${pages[0] + 1} 页`;
  return `第 ${pages[0] + 1} ~ ${pages[pages.length - 1] + 1} 页`;
}; 